/* eslint-disable no-console */
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

import { LABEL_DEVICE_CHECK, LABEL_INSPECTOR, PLACEHOLDER_CONSTRUCTIONSITE, PLACEHOLDER_INSPECTOR } from "@configs";
import { formatDate, useConstructionSites } from "@utils";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useParams } from "react-router-dom";
import { AppCustomeSelect, AppInput, AppSelect, AppTextAreaNumber, AppTimePicker } from "src/Components/Common";
import { useTimeSheetContext } from "../../context";
import { TimeSheetNightShiftFormSchemaType } from "../../validation";
import { SiteConstructionsFormWidget } from "./site-constructions-form.widget";
import queryString from "query-string";
import dayjs from "dayjs";
import { CheckDefaultValue, StyledAlcolCheck, StyledBorder } from "../form-sheet-night-shift";
import { CustomBlueCheckbox } from "../../styles";
import "../timesheetWidget.css";
import { useEffect, useMemo, useState } from "react";
import { useAppSelector, selectAuth } from "@redux";
import { useUserSelectionHistories } from "src/Utils/Hooks/useUserSelectionHistories";
import { useConstructionSelectionHistories } from "src/Utils/Hooks/useConstructionSelectionHistories";

export function FirstFormSheetNightAndDay() {
  const form = useFormContext<TimeSheetNightShiftFormSchemaType>();

  const auth = useAppSelector(selectAuth);
  const id = auth?.userInfo?.id;
  const { employees, optionVehicles, optionSiteConstructions, loadingSiteConstructions } = useTimeSheetContext();
  const { list, storeSelection } = useUserSelectionHistories(id ?? 0);
  const { storeConstructionSelection } = useConstructionSelectionHistories(id ?? 0);

  const [employeeFirstOptions, setEmployeeFirstOptions] = useState<any[]>([]);
  const [constructionFirstOptions, setConstructionFirstOptions] = useState<any>([]);

  useEffect(() => {
    setEmployeeFirstOptions(employees);
  }, [employees]);

  useEffect(() => {
    setConstructionFirstOptions(optionSiteConstructions);
  }, [optionSiteConstructions]);

  useEffect(()=>{
    if (list?.length) {
      const newEmployeeOption = list.map((item) => ({
        label: `${item.last_name} ${item.first_name}`,
        value: item.id,
      }));
      setEmployeeFirstOptions(newEmployeeOption);
    } else {
      setEmployeeFirstOptions([]);
    }
  },[list]);

  let newOptionConstruction;

  const {
    control,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
  } = form;

  const parsed = queryString.parse(location.search);

  const params: any = useParams();

  // const watchConstructions = useWatch({ name: `list_constructions` });
  const watchConstructions = useWatch({
    name: `list_constructions`,
    defaultValue: [],
  });

  const defaultConstructionValues = useMemo(() => {
    if (!watchConstructions || constructionFirstOptions.length === 0) return [];

    const constructionsListValue = watchConstructions.map((construction) => construction.construction_id);

    const inactiveOptionConstruction = watchConstructions.map((construction) => {
      if (construction?.listConstruction?.name && construction?.listConstruction?.id) {
        return {
          label: construction.listConstruction.name,
          value: construction.listConstruction.id,
        };
      }
      return null;
    }).filter(Boolean);

    const isDuplicate = (item) =>
      constructionFirstOptions.some((option) => option.value === item.value);

    const mergedOptions = [
      ...inactiveOptionConstruction.filter((item) => !isDuplicate(item)),
      ...constructionFirstOptions,
    ];

    return mergedOptions.filter((construction) =>
      constructionsListValue.includes(construction.value)
    );

  }, [watchConstructions, constructionFirstOptions]);

  //申請画面から値を入れた際に失敗するので、コメントアウト
  // if (watchConstructions && optionSiteConstructionsSorted.length > 0 && (params?.id || parsed?.copy)) {
  //   const constructionsListValue = watchConstructions.map((construction) => {
  //     return construction.construction_id;
  //   });
  //   const inactiveOptionConstruction = watchConstructions?.map((construction) => {
  //     if (construction?.listConstruction?.name && construction?.listConstruction?.id) {
  //       return {
  //         label: construction?.listConstruction?.name,
  //         value: construction?.listConstruction?.id,
  //       };
  //     }
  //     return null;
  //   });

  //   const filteredInactiveOptionConstruction = inactiveOptionConstruction.filter((item) => item !== null);

  //   // Kiểm tra xem giá trị của phần tử có trùng với giá trị của optionSiteConstructionsSorted hay không
  //   const isDuplicate = (item) => optionSiteConstructionsSorted?.some((option) => option.value === item.value);

  //   // thêm construction trả về từ timesheet vào option list các construction thành 1 mảng option mới
  //   newOptionConstruction = [...filteredInactiveOptionConstruction.filter((item) => !isDuplicate(item)), ...optionSiteConstructionsSorted];

  //   defaultConstructionValues = constructionsListValue;

  //   defaultConstructionValues = newOptionConstruction?.filter((construction) => constructionsListValue.some((constructionChecked) => constructionChecked === construction.value));
  // }

  return (
    <>
      <div className="boxWrapper">
        <h3>夜勤</h3>
        <div className="radio">
          <StyledBorder>
            <label className="label">アルコールチェック</label>
            <div>
              <FormGroup>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Controller
                    name="alcohol_check"
                    control={control}
                    defaultValue={true}
                    render={({ field: { onChange, value, ref } }) => (
                      <>
                        <Checkbox inputRef={ref} checked={!!value} onChange={(_, checked) => onChange(checked)} />
                        <FormControlLabel control={<></>} label="チェック済み" style={{ marginLeft: "5px" }} />
                      </>
                    )}
                  />
                </div>
              </FormGroup>
              {errors?.alcohol_check && (
                <p
                  style={{
                    color: "#FF597B",
                    fontSize: "13px",
                  }}
                >
                  {errors?.alcohol_check?.message === "Required" ? "この項目は必須です" : errors?.alcohol_check?.message}
                </p>
              )}
            </div>
          </StyledBorder>
          <StyledBorder>
            {/* <Box> */}
            <div className="label">日付</div>
            <div className="input select time">
              <Controller
                name="check_date"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <input
                    type="date"
                    value={value ? dayjs(value).format("YYYY-MM-DD") : ""}
                    onChange={(event) => {
                      const formattedValue = dayjs(event.target.value).format("YYYY-MM-DD");
                      onChange(formattedValue);
                    }}
                    disabled
                    className="timesheetDate"
                  />
                )}
              />
            </div>
            {/* </Box> */}
          </StyledBorder>
          {/* <Controller
            name="alcohol_default_check"
            control={control}
            defaultValue={false}
            render={({ field }) => (
              <CheckDefaulAlcoltValueFirstForm>
                <p>固定</p>
                <input type="checkbox" {...field} checked={field.value} value={field.value ? "true" : "false"} />
              </CheckDefaulAlcoltValueFirstForm>
            )}
          /> */}
          <StyledAlcolCheck>
            {/* <Box style={{ display: "flex", justifyContent: "space-between" }}> */}
            {/* <StyledAlcolCheckFirstForm> */}
            <div>
              <label className="label">出勤時 </label>
              <div className="wrap__alcohol-start">
                <Controller
                  name={`start_time_check_alcohol`}
                  control={control}
                  render={({ field: { value, onChange }, fieldState: { error } }) => {
                    const formatValue = dayjs(value, "HH:mm").toDate();
                    return (
                      <div>
                        <AppTimePicker
                          value={formatValue}
                          handleChange={(value) => {
                            const formatValue = formatDate({
                              date: value,
                              format: "HH:mm",
                            });

                            onChange(formatValue);
                          }}
                        />
                        {error && (
                          <p
                            style={{
                              color: "#FF597B",
                              fontSize: "13px",
                              margin: "8px",
                            }}
                          >
                            {error?.message === "Required" ? "この項目は必須です" : error?.message}{" "}
                          </p>
                        )}
                      </div>
                    );
                  }}
                />
                <div
                // className="input"
                // style={{
                //   marginTop: "10px",
                //   display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // }}
                >
                  <Controller
                    name={`start_capacity_alcohol`}
                    control={control}
                    render={({ field: { value, onChange }, fieldState: { error } }) => (
                      <div
                      // className="wrap__alcohol-start"
                      // style={{
                      //   display: "flex",
                      //   flexDirection: "column",
                      //   marginRight: "-20px",
                      //   marginLeft: "10px",
                      // }}
                      >
                        <AppTextAreaNumber value={value} handleChange={onChange} />
                        {error && (
                          <p
                            style={{
                              color: "#FF597B",
                              fontSize: "13px",
                              margin: "8px",
                            }}
                          >
                            {error?.message === "Required" ? "この項目は必須です" : error?.message}{" "}
                          </p>
                        )}
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
            <div>
              <label className="label">退勤時</label>
              <div className="wrap__alcohol-end">
                <Controller
                  name={`end_time_check_alcohol`}
                  control={control}
                  render={({ field: { value, onChange }, fieldState: { error } }) => {
                    const formatValue = dayjs(value, "HH:mm").toDate();
                    return (
                      <div>
                        <AppTimePicker
                          value={formatValue}
                          handleChange={(value) => {
                            const formatValue = formatDate({
                              date: value,
                              format: "HH:mm",
                            });

                            onChange(formatValue);
                          }}
                        />
                        {error && (
                          <p
                            style={{
                              color: "#FF597B",
                              fontSize: "13px",
                              margin: "8px",
                            }}
                          >
                            {error?.message === "Required" ? "この項目は必須です" : error?.message}{" "}
                          </p>
                        )}
                      </div>
                    );
                  }}
                />
                <div
                // className="input"
                // style={{
                //   marginTop: "10px",
                //   display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // }}
                >
                  <Controller
                    name={`end_capacity_alcohol`}
                    control={control}
                    render={({ field: { value, onChange }, fieldState: { error } }) => (
                      <div
                      // className="wrap__alcohol-end"
                      // style={{
                      //   display: "flex",
                      //   flexDirection: "column",
                      //   marginRight: "-20px",
                      //   marginLeft: "10px",
                      // }}
                      >
                        <AppTextAreaNumber value={value} handleChange={onChange} />
                        {error && (
                          <p
                            style={{
                              color: "#FF597B",
                              fontSize: "13px",
                              margin: "8px",
                            }}
                          >
                            {error?.message === "Required" ? "この項目は必須です" : error?.message}{" "}
                          </p>
                        )}
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
            {/* </StyledAlcolCheckFirstForm> */}
            {/* </Box> */}
            <div className="check">
              <Controller
                name="alcohol_default_check"
                control={control}
                defaultValue={false}
                render={({ field }) => (
                  <CheckDefaultValue>
                    <CustomBlueCheckbox checked={field.value}
                      onChange={(e) => field.onChange(e.target.checked)} />
                    {/* <input type="checkbox" {...field} checked={field.value} value={field.value ? "true" : "false"} /> */}
                    <p>固定</p>
                  </CheckDefaultValue>
                  // <CheckDefaulAlcoltValueFirstForm>
                  //   <p>固定</p>
                  //   <input type="checkbox" {...field} checked={field.value} value={field.value ? "true" : "false"} />
                  // </CheckDefaulAlcoltValueFirstForm>
                )}
              />
            </div>
          </StyledAlcolCheck>
          <StyledBorder>
            {/* <Box> */}
            <label className="label">{LABEL_INSPECTOR}</label>
            <div className="input select wrap-checkbox">
              {employees?.length && (
                <Controller
                  name="inspector_id"
                  control={control}
                  render={({ field: { onChange, value }, fieldState: { error } }) => {
                    return (
                      <AppSelect
                        error={error?.message}
                        options={employeeFirstOptions}
                        value={String(value)}
                        handleChange={(value, action) => {
                          onChange(String(value));
                          if (action === "clear") {
                            onChange("");
                          }
                          storeSelection({ user_id: Number(id), selected_user_id: value });
                        }}
                        isClearable
                        placeholder={PLACEHOLDER_INSPECTOR}
                      />
                    );
                  }}
                />
              )}
              <Controller
                name="inspector_default_check"
                control={control}
                defaultValue={false}
                render={({ field }) => (
                  <CheckDefaultValue>
                    <CustomBlueCheckbox checked={field.value}
                      onChange={(e) => field.onChange(e.target.checked)} />
                    <p>固定</p>
                  </CheckDefaultValue>
                  // <CheckDefaultValueFirstForm className="noti__item-checkboxContain">
                  //   <p>固定</p>
                  //   <input type="checkbox" {...field} checked={field.value} value={field.value ? "true" : "false"} />
                  // </CheckDefaultValueFirstForm>
                )}
              />
            </div>
            {/* </Box> */}
          </StyledBorder>
          <StyledBorder>
            {/* <Box> */}
            <label className="label">運転者</label>
            <div className="input select wrap-checkbox">
              {employees?.length && (
                <Controller
                  name="driver_id"
                  control={control}
                  render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <AppSelect
                      error={error?.message}
                      options={employeeFirstOptions}
                      value={String(value)}
                      handleChange={(value, action) => {
                        onChange(String(value));
                        if (action === "clear") {
                          onChange("");
                        }
                        storeSelection({ user_id: Number(id), selected_user_id: value });
                      }}
                      isClearable
                      placeholder="ドライバーを選択"
                    />
                  )}
                />
              )}
              <Controller
                name="driver_default_check"
                control={control}
                defaultValue={false}
                render={({ field }) => (
                  <CheckDefaultValue>
                    <CustomBlueCheckbox checked={field.value}
                      onChange={(e) => field.onChange(e.target.checked)} />
                    <p>固定</p>
                  </CheckDefaultValue>
                  // <CheckDefaultValueFirstForm className="noti__item-checkboxContain">
                  //   <p>固定</p>
                  //   <input type="checkbox" {...field} checked={field.value} value={field.value ? "true" : "false"} />
                  // </CheckDefaultValueFirstForm>
                )}
              />
            </div>
            {/* </Box> */}
          </StyledBorder>
          <StyledBorder>
            {/* <Box> */}
            <label className="label">車両名</label>
            <div className="input select wrap-checkbox">
              {optionVehicles?.length && (
                <Controller
                  name="vehicle_id"
                  control={control}
                  render={({ field: { value, onChange }, fieldState: { error } }) => (
                    <AppSelect
                      error={error?.message}
                      options={optionVehicles}
                      value={String(value)}
                      handleChange={(value, action) => {
                        onChange(String(value));
                        if (action === "clear") {
                          onChange("");
                        }
                      }}
                      isClearable
                      placeholder="車両を選択"
                    />
                  )}
                />
              )}
              <Controller
                name="vehicle_default_check"
                control={control}
                defaultValue={false}
                render={({ field }) => (
                  <CheckDefaultValue>
                    <CustomBlueCheckbox checked={field.value}
                      onChange={(e) => field.onChange(e.target.checked)} />
                    <p>固定</p>
                  </CheckDefaultValue>
                  // <CheckDefaultValueFirstForm className="noti__item-checkboxContain">
                  //   <p>固定</p>
                  //   <input type="checkbox" {...field} checked={field.value} value={field.value ? "true" : "false"} />
                  // </CheckDefaultValueFirstForm>
                )}
              />
            </div>
            {/* </Box> */}
          </StyledBorder>
          <StyledBorder>
            {/* <Box> */}
            <label className="label">{LABEL_DEVICE_CHECK}</label>
            <div className="wrap-checkbox">
              <Controller
                name="device_check"
                control={control}
                render={({ field: { value, onChange }, fieldState: { error } }) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <AppInput name="deviceCheck" handleChange={onChange} value={value ? String(value) : ""} />
                    {error && (
                      <p
                        style={{
                          color: "#FF597B",
                          fontSize: "13px",
                          margin: "8px",
                        }}
                      >
                        {error?.message}
                      </p>
                    )}
                  </div>
                )}
              />
              <Controller
                name="device_default_check"
                control={control}
                defaultValue={false}
                render={({ field }) => (
                  <CheckDefaultValue>
                    <CustomBlueCheckbox checked={field.value}
                      onChange={(e) => field.onChange(e.target.checked)} />
                    <p>固定</p>
                  </CheckDefaultValue>
                  // <CheckDefaultValueFirstForm className="noti__item-checkboxContain">
                  //   <p>固定</p>
                  //   <input type="checkbox" {...field} checked={field.value} value={field.value ? "true" : "false"} />
                  // </CheckDefaultValueFirstForm>
                )}
              />
            </div>
            {/* </Box> */}
          </StyledBorder>
          {/* <Divider sx={{ mx: "20px" }} /> */}
          <div className="input select">
            <label className="label">現場名</label>

            <AppCustomeSelect
              placeholder={PLACEHOLDER_CONSTRUCTIONSITE}
              onChange={(values) => {

                const list = Array.isArray(values) ? values : [values];

                if (list.length === 0) {
                  setValue("list_constructions", []);
                  return;
                }

                const lastValue = list[list.length - 1]?.value;
                if (!lastValue) {
                  return;
                }
                storeConstructionSelection({user_id:id, selected_construction_id: lastValue});
                const prev = getValues("list_constructions") || [];
                // const listConstructions = getValues("list_constructions");
                clearErrors("list_constructions");
                if (list.length > prev.length) {
                  setValue("list_constructions", [
                    ...prev,
                    {
                      construction_id: lastValue,
                      start_at: "",
                      stop_at: "",
                      break_time: 0,
                      weather_id: "",
                      memo: "",
                      livelet_employee: [],
                      contractors: [],
                    },
                  ]);
                  return;
                }

                const removed = prev.find(({ construction_id }) =>
                  !list.some(({ value }) => construction_id === value)
                );
                setValue(
                  "list_constructions",
                  prev.filter((c) => c.construction_id !== removed?.construction_id)
                );

                // const valueSelect = listConstructions.find(({ construction_id }) => !values.some(({ value }) => construction_id === value));

                // const valueListConstructions = listConstructions.filter((construction) => construction.construction_id !== valueSelect?.construction_id);

                // setValue("list_constructions", valueListConstructions);
              }}
              value={defaultConstructionValues}
              options={constructionFirstOptions}
              isLoading={loadingSiteConstructions}
              isMulti
            />
            {errors.list_constructions && (
              <p
                style={{
                  color: "#FF597B",
                  fontSize: "13px",
                  margin: "8px",
                }}
              >
                {errors?.list_constructions.message}
              </p>
            )}
          </div>
          {constructionFirstOptions && <SiteConstructionsFormWidget optionSiteConstructions={newOptionConstruction || constructionFirstOptions} />}
        </div>
      </div>
    </>
  );
}

// export const StyledAlcolCheckFirstForm = styled.div`
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     /* align-items: center; */
//     /* @media (min-width: 620px) {
//         margin-left: -10px !important;
//     } */
//     .wrap__alcohol {
//         &-start {
//             margin-right: 10px;
//             @media (max-width: 620px) {
//                 max-width: 250px !important;
//             }
//         }
//         &-end {
//             margin-right: 10px;
//             @media (max-width: 620px) {
//                 max-width: 250px !important;
//             }
//         }
//     }

//     @media (max-width: 620px) {
//         display: flex;
//         flex-direction: column;
//         justify-content: flex-start !important;
//     }
// `;

// export const CheckDefaultValueFirstForm = styled.div`
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     align-items: center;
//     margin-left: 10px;
//     width: 35px;
//     p {
//         line-height: 1.4;
//     }
//     input {
//         width: 30px;
//         height: 20px;
//     }
// `;

// export const CheckDefaulAlcoltValueFirstForm = styled.div`
//     display: flex;
//     flex-direction: column;
//     width: 35px;
//     input {
//         width: 20px;
//         height: 20px;
//     }
// `;
